import { render, staticRenderFns } from "./FolderFormModal.vue?vue&type=template&id=3976af64"
import script from "./FolderFormModal.vue?vue&type=script&lang=js"
export * from "./FolderFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports